import React from 'react';

const ConstellationSVG = ({ className = '' }) => {
  return (
    <svg 
      className={`w-full h-full ${className}`}
      viewBox="0 0 800 600" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Constellation lines */}
      <g stroke="currentColor" strokeWidth="0.5" className="text-cosmic-300">
        <line x1="100" y1="100" x2="180" y2="140" strokeDasharray="3 3" />
        <line x1="180" y1="140" x2="220" y2="200" strokeDasharray="3 3" />
        <line x1="220" y1="200" x2="160" y2="260" strokeDasharray="3 3" />
        <line x1="160" y1="260" x2="100" y2="240" strokeDasharray="3 3" />
        <line x1="100" y1="240" x2="100" y2="100" strokeDasharray="3 3" />
        
        <line x1="500" y1="80" x2="560" y2="120" strokeDasharray="3 3" />
        <line x1="560" y1="120" x2="620" y2="100" strokeDasharray="3 3" />
        <line x1="620" y1="100" x2="680" y2="160" strokeDasharray="3 3" />
        
        <line x1="300" y1="400" x2="360" y2="440" strokeDasharray="3 3" />
        <line x1="360" y1="440" x2="420" y2="420" strokeDasharray="3 3" />
        <line x1="420" y1="420" x2="480" y2="460" strokeDasharray="3 3" />
      </g>
      
      {/* Stars */}
      <g fill="currentColor" className="text-cosmic-400">
        <circle cx="100" cy="100" r="2" />
        <circle cx="180" cy="140" r="2" />
        <circle cx="220" cy="200" r="2" />
        <circle cx="160" cy="260" r="2" />
        <circle cx="100" cy="240" r="2" />
        
        <circle cx="500" cy="80" r="2" />
        <circle cx="560" cy="120" r="2" />
        <circle cx="620" cy="100" r="2" />
        <circle cx="680" cy="160" r="2" />
        
        <circle cx="300" cy="400" r="2" />
        <circle cx="360" cy="440" r="2" />
        <circle cx="420" cy="420" r="2" />
        <circle cx="480" cy="460" r="2" />
        
        {/* Small scattered stars */}
        <circle cx="150" cy="50" r="1" opacity="0.6" />
        <circle cx="400" cy="120" r="1" opacity="0.6" />
        <circle cx="600" cy="300" r="1" opacity="0.6" />
        <circle cx="200" cy="500" r="1" opacity="0.6" />
        <circle cx="700" cy="400" r="1" opacity="0.6" />
      </g>
    </svg>
  );
};

export default ConstellationSVG;